<template>
    <div class="vessel-analytics">
        <GrafanaIframe :url="url" :title="title || 'Vessel Analytics'" />
    </div>
</template>

<script lang="ts" setup>
import GrafanaIframe from '@/components/GrafanaIframe.vue'
import { computed, onMounted } from 'vue'
import { useBreadCrumbsStore } from '@/stores/breadCrumbs'

const props = defineProps<{
    accountId?: number
    vesselId?: number
    monitorId: string
    orgId?: string | number
    title?: string
}>()

const breadCrumbsStore = useBreadCrumbsStore()

const url = computed(() => {
    return `${import.meta.env.VITE_ANALYTICS_SINGLE_VESSEL_URL}?var-VesselId=${props.monitorId}&orgId=${props.orgId}`
})

function _updateBreadCrumb() {
    const items: { text: string; to?: object }[] = [{ text: 'Home', to: { name: 'home' } }]

    if (props.accountId !== undefined) {
        items.push({ text: `Account ${props.accountId}`, to: { name: 'AccountDetails', params: { accountId: props.accountId } } })
    }
    if (props.accountId !== undefined && props.vesselId !== undefined) {
        items.push({ text: `Vessel ${props.vesselId}`, to: { name: 'VesselDetails', params: { accountId: props.accountId, vesselId: props.vesselId } } })
    }
    items.push({ text: 'Analytics' })

    breadCrumbsStore.$patch({ items })
}

onMounted(async function init() {
    _updateBreadCrumb()
})
</script>

<style lang="scss" scoped>
.v-card {
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.v-card-title {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px;
}

.vessel-analytics {
    height: 100%;
}
</style>
